import React from 'react';
import ReactDOM from 'react-dom';
import Handlebars from "handlebars";
import { Card, CardContent, Button } from '@material-ui/core';
import styled, { StyleSheetManager, createGlobalStyle } from 'styled-components';
import { ButtonWrapperFilter } from '../../styles/common-styles';

const GlobalPrintStyles = createGlobalStyle`
   
  @media print {
    @page :header {
      display: none;
    }
    .print {
      display: none;
    }
  }
`;

const ExportContainer = styled.div`
  margin-top: 20px;
`;

const PrintButtonWrapper = styled(ButtonWrapperFilter)`
    margin-bottom: 13px;
    margin-right: 102px;
    border-radius: 4px;

    & button {
        border-radius: 4px;
        border: 0px;
        
        & span {
            font-weight: 400 !important;
        }
    }
`

// Register the eq helper for comparison
Handlebars.registerHelper('eq', function (a, b) {
    return a === b;
});

// Register the length helper to get array length
Handlebars.registerHelper('length', function (array) {
    return array ? array.length : 0;
});

// Register the and helper for logical AND operations
Handlebars.registerHelper('and', function (a, b) {
    return a && b;
});

// Register the gt helper for greater than comparison
Handlebars.registerHelper('gt', function (a, b) {
    return a > b;
});

export const RenderComponent = ({ template, templateData, myWindow }) => {

    const Aftertemplate = Handlebars.compile(template);

    const handleExportToPDF = () => {
        myWindow.scroll({ top: 0, left: 0 });
        myWindow.print();
    };

    return (
        <>
            <GlobalPrintStyles />
            <Card>
                <CardContent>
                    <div>
                        <div dangerouslySetInnerHTML={{ __html: Aftertemplate(templateData) }}></div>
                        <ExportContainer>
                            <PrintButtonWrapper>
                                <Button 
                                    className="BgYellowOrange print" 
                                    variant="contained" 
                                    size="large"
                                    onClick={handleExportToPDF}
                                >
                                    Export to PDF
                                </Button>
                            </PrintButtonWrapper>
                        </ExportContainer>
                    </div>
                </CardContent>
            </Card>
        </>
    )
}

const ExportComponent = (templateHtml, templateCss, templateData) => {
    let templateArray = templateHtml.split('<head>');
    
    let cssPart = `<head><style>${[templateCss]}</style></head>`;
    let mergedTemplate = templateArray[0].concat(cssPart, templateArray[1])
    
    if (templateData !== "") {
        let myWindow = window.open("", "MsgWindow", "location=1,status=1,scrollbars=1, width=1150,height=800");
        
        ReactDOM.render(
            <StyleSheetManager target={myWindow.document.head}>
                <RenderComponent
                    template={mergedTemplate}
                    templateData={templateData}
                    myWindow={myWindow}
                />
            </StyleSheetManager>,
            myWindow.document.body
        );
    }
}

export default ExportComponent;